import { Heading } from 'turnip/Heading/Heading';
import { Stack } from 'turnip/Stack/Stack';
import type { Maybe } from 'types/Utilities';

interface PageTitleProps {
  children: React.ReactNode;
  addendum?: Maybe<string>;
  /**
   * Actions to display with the title.
   * Typically, this is a `Button`, which should use `size="sm"`.
   */
  actions?: React.ReactNode;
}

function PageTitle({ children, addendum, actions }: PageTitleProps) {
  const title = (
    <Heading level={1} size="text-3xl">
      {addendum ? (
        <>
          {children}:{' '}
          <span className="block break-all text-base font-normal lg:inline lg:break-normal lg:text-3xl">
            {addendum}
          </span>
        </>
      ) : (
        children
      )}
    </Heading>
  );

  if (!actions) {
    return title;
  }

  return (
    <Stack
      direction={{ base: 'vertical', md: 'horizontal' }}
      justifyContent="space-between"
      gap={4}
    >
      {title}

      {actions && (
        <div className="flex items-start">
          <div className="flex items-center gap-2">{actions}</div>
        </div>
      )}
    </Stack>
  );
}

export { PageTitle };
export type { PageTitleProps };
